import { refs, domReady, dispatchEvent } from '../modules/utils.js';

class VideoWrapper extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#listeners();
  }

  #listeners() {
    this.addEventListener('click', (e) => dispatchEvent('videowrapper:click'));
    document.addEventListener('layoutoverlay:out', () => {
      // this.refs.video.pause();
      setTimeout(() => {
        this.refs.video.currentTime = 0;
      }, 500);
    });
  }
}

customElements.define('video-wrapper', VideoWrapper);
